import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import {
  AnnouncementIcon,
  CertificateIcon,
  RaiseIcon,
  TargetIcon,
  UserIcon,
  EngagingIcon,
} from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const data = [
  {
    icon: <TargetIcon />,
    title: `Improve ad targeting and return on ad spend (ROAS)`,
    description: `Build lookalike audiences based on customers with a high likelihood to purchase or high LTV. Suppress ads to users with low likelihood to purchase or low LTV to conserve ad spend.`,
  },
  {
    icon: <AnnouncementIcon />,
    title: `Increase performance of promotional and lifecycle campaigns`,
    description: `Create more personalized emails, SMS, WhatsApp, and push notifications for customers no matter where they are in their journey or which buying groups they are in—like discount vs full-price buyers.`,
  },
  {
    icon: <UserIcon />,
    title: `Personalize online experiences`,
    description: `Update your web and mobile experiences to showcase different products or promotions based on their propensity to purchase or engage with your content.`,
  },
  {
    icon: <RaiseIcon />,
    title: `Boost upsell and cross-sell`,
    description: `Drive greater upsell and cross-sell opportunities by launching timely campaigns showcasing personalized items when customers are most likely to buy.`,
  },
  {
    icon: <CertificateIcon />,
    title: `Enhance loyalty programs`,
    description: `Quickly spot customers with high predicted LTV to invite into VIP loyalty programs or send special personalized offers.`,
  },
  {
    icon: <EngagingIcon />,
    title: `Bolster win-back campaigns`,
    description: `Proactively identify disengaged or at-risk customers for targeted win-back and retention campaigns.`,
  },
]

const copy = {
  title: `Boost campaign performance and ROI`,
  description: `Easily identify, target, and launch campaigns for users who are most likely to convert or take a desired action across all your customer channels and journeys.`,
}

const BoostCampaign = () => {
  return (
    <SectionBase variant="centered">
      <Section.Copy>
        <CopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.title}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </CopyTextBase>
      </Section.Copy>
      <Section.Contents>
        <StyledColumnTrack
          columns={1}
          overrides={{
            md: 3,
          }}
        >
          {data.map(({ icon, title, description }, key) => (
            <FeatureBoxBase alignment="left" headerPosition="top" key={key}>
              <FeatureBox.Header>
                <StyledIconWrapper background="light" elevation={1} variant="circle">
                  {icon}
                </StyledIconWrapper>
              </FeatureBox.Header>
              <FeatureBox.Body>
                <FeatureBox.Title>{title}</FeatureBox.Title>
                <FeatureBox.Text>{description}</FeatureBox.Text>
              </FeatureBox.Body>
            </FeatureBoxBase>
          ))}
        </StyledColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

const StyledIconWrapper = styled(IconWrapper)`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
  color: ${({ theme }) => theme.palette.twilio.gray[100]};
`

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
`

export default BoostCampaign
